import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Flex, Icon, Text, Link } from '@chakra-ui/react';
import OrgNavbar from './OrgNavbar';
import OrgSidebar from './OrgSidebar';
import { FaBinoculars } from 'react-icons/fa';
import { useUser } from "../../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import TrialStatusBanner from '../../layout/TrialStatusBanner';

const OrgProtectedLayout = () => {
  const { user, isTourUser, logout } = useUser();
  const { t } = useTranslation();

  const handleLogout = () => {
    logout();
  };

  return (
    <Flex>
      {/* Sidebar */}
      <Box display={{ base: 'none', md: 'block' }}>
        <OrgSidebar />
      </Box>

      {/* Main Content */}
      <Box ml={{ base: 0, md: '250px' }} width="100%">
        {user?.is_simulated && (
          <Box
            bg="repeating-linear-gradient(
              45deg,
              gold,
              gold 10px,
              yellow 10px,
              yellow 20px
            )"
            color="black"
            p={2}
            textAlign="center"
            fontWeight="bold"
          >
            You are simulating a user account.{' '}
            <Link onClick={handleLogout} textDecoration="underline">
              Click here to return to login.
            </Link>
          </Box>
        )}

        {isTourUser && (
          <Box
            width="100%"
            bg="orange"
            color="white"
            py={2}
            textAlign="center"
            zIndex="banner"
          >
            <Text fontWeight="bold"><Icon as={FaBinoculars} mr={2} /> {t("common.tour_mode")}</Text>
          </Box>
        )}

        <OrgNavbar />
        <TrialStatusBanner />

        {/* Content Area (where pages load) */}
        <Box p={4} className="content-box">
          <Outlet /> {/* This renders the page component for each route */}
        </Box>
      </Box>
    </Flex>
  );
};

export default OrgProtectedLayout;
